<template>
    <div>
      <div class="d-flex justify-content-end">
        <b-button variant="primary" v-b-modal.addReconciliationModal class="my-1">
          Add Reconciliation
        </b-button>
      </div>
  
      <!-- Add Bank Account Modal -->
      <b-modal id="addReconciliationModal" title="Add Reconciliation" v-model="showReconciliationModal" hide-footer centered>
    <b-form @submit.prevent="AddBankStatement">
      <b-row>
        <div class="m-4">

          <b-form-group label="Upload File" label-for="file-input ">
         
         <b-form-file
           id="file-input"
           v-model="file"
           placeholder="Choose a file or drop it here..."
           drop-placeholder="Drop file here..."
         />
       </b-form-group>

       <!-- Display Selected File -->
       <b-card-text class="my-1">
         Selected file: <strong>{{ file ? file.name : 'No file selected' }}</strong>
       </b-card-text>
        </div>
        <!-- File Input -->
        
      </b-row>

      <div class="d-flex justify-content-end">
            <b-button variant="secondary" @click="closeAddModal" class="mr-2">Cancel</b-button>
            <b-button type="submit" variant="primary">Submit</b-button>
          </div>

    </b-form>
  </b-modal>
     
      <!-- View Bank Account Modal -->
      <b-modal id="viewModal" title="View Income" v-model="showViewModal" centered>
        
  
        <template #modal-footer></template>
      </b-modal>
      <!-- Edit Bank Account Modal -->
      <b-modal id="editModal" title="Edit Income" v-model="showEditModal" centered>
      </b-modal>
  
      <!-- Bank List -->
      <b-table :items="reconciliation" :fields="fields" :current-page="currentPage" :per-page="perPage"
        :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" responsive striped>
  
        <template #cell(actions)="row">
          <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
            <template #button-content>
              <feather-icon icon="MoreVerticalIcon" size="16" class="text-body align-middle mr-25" />
            </template>
            
            <b-dropdown-item :to="{ name: 'reconciliationView', params: { id: row.item.id } }">
              <feather-icon icon="EyeIcon" class="mr-50" />
              <span>View</span>
            </b-dropdown-item>
            
          </b-dropdown>
        </template>
  
        
      </b-table>
  
      <div class="d-flex justify-content-center mb-1">
        <b-spinner variant="success" label="Spinning" block v-if="loading" style="width: 3rem; height: 3rem"></b-spinner>
      </div>
  
      <b-col cols="12">
        <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" align="center" size="sm"
          class="my-0" />
      </b-col>
  
    </div>
  </template>
  
  <script>
  import {
    BFormInput,
    BFormGroup,
    BTable,
    BPagination,
    BRow,
    BCol,
    BButton,
    BInputGroup,
    BInputGroupAppend,
    BInputGroupPrepend,
    BFormTextarea,
    VBTooltip,
    BFormSelect,
    BBadge,
    BModal,
    VBModal,
    BDropdown,
    BFormFile,
    BDropdownItem,
    BFormCheckbox,
    BFormDatepicker ,
    BSpinner, BForm
  } from "bootstrap-vue";
  
  import income from "../income/income.vue";
  import CreditCardIcon from "./CreditCardIcon.vue";
  import AddBankAccIcon from "./AddBankAccIcon.vue";
  import ReconcileIcon from "./ReconcileIcon.vue";
  import FundTransfersIcon from "./FundTransfersIcon.vue";
  import AccStatementIcon from "./AccStatementIcon.vue";
  import CheckTransactionIcon from "./CheckTransactionIcon.vue";
  import BankStatementIcon from "./SalesReportIcon.vue";
  import vSelect from "vue-select";
  import flatPickr from "vue-flatpickr-component";
  import SearchBar from "@/components/search-component/SearchBar.vue";
  import { mapActions, mapGetters } from "vuex";
  import axios from "axios";
import bankStatement from "@/store/bankStatement";
import reconciliation from "@/router/routes/accounting/reconciliation";
  export default {
    components: {
      BFormInput,
      BFormGroup,
      BTable,
      BPagination,
      BRow,
      BCol,
      BFormFile,
      BButton,
      BFormDatepicker ,
      BInputGroup,
      BInputGroupAppend,
      BInputGroupPrepend,
      BFormTextarea,
      BFormSelect,
      BBadge,
      BModal,
      CreditCardIcon,
      AddBankAccIcon,
      BDropdown,
      BDropdownItem,
      vSelect,
      flatPickr,
      BFormCheckbox, SearchBar,
      ReconcileIcon, BankStatementIcon, CheckTransactionIcon, FundTransfersIcon, AccStatementIcon, bankStatement,
      BSpinner, BForm
    },
    directives: {
      "b-tooltip": VBTooltip,
      "b-modal": VBModal,
    },
    data() {
      return {
        bankId: this.$route.params.id,
        reconciliation:[],
        filters: {
        date: null, 
        file: null,
        bankName: "",
        name: "",
        description: "",
        currency: "",
        date:"",
        currentBalance: "",
        isActive: "",
        isExistingAccount: false,
        },
        showReconciliationModal: false,
        showEditModal: false,
        showAddCCModal: false,
        showViewModal: false,
        items: [ ],
        selectedBank: {
          bankName: "",
          name: "",
          code: "",
          currency: "",
          accountNumber: "",
          currentBalance: 0,
          description: "",
          type: "",
          openingBalanceDate: "",
          openingBalance: 0,
          isActive: "",
          isExistingAccount: false
        },
        optionBanks: [{ title: "MCB" }, { title: "SBM" }, { title: "Other" }],
        optionAccType: [
          { title: "Checking" },
          { title: "Savings" },
          { title: "Credit Card" },
        ],
        
        newBank: {
          bankName: "",
          name: "",
          code: "",
          currency: "",
          accountNumber: "",
          currentBalance: 0,
          description: "",
          type: "",
          openingBalanceDate: "",
          openingBalance: 0,
          isActive: ""
        },
        searchTerm: "",
        sortBy: "bankName",
        sortDesc: false,
        currentPage: 1,
        perPage: 10,
        infoModal: {
          id: "info-modal",
          title: "",
          content: "",
        },
        fields: [
          { key: "name", label: "Name", filterable: true, sortable: true },
          { key: "uploadedDate", label: "Date", filterable: true, sortable: true , formatter: this.formatDate },
          { key: "status", label: "Status", filterable: true },
          { key: "actions", label: "Actions" },
        ],
        filters: {
        
          name: "",
          date: "",
          
          isActive: null,
        },

      };
    },
    methods: {
      formatDate(value) {
    if (!value) return "";
    return value.split("T")[0]; // Extract only the date part
  },
      successAdd() {
        this.$swal({
          title: "Bank Added!",
          text: "You have successfully added a bank!",
          icon: "success",
          customClass: {
            confirmButton: "btn btn-primary",
          },
          buttonsStyling: false,
        });
      },
      // error
      errorAdd() {
        this.$swal({
          title: "Error!",
          text: " Failed!",
          icon: "error",
          customClass: {
            confirmButton: "btn btn-primary",
          },
          buttonsStyling: false,
        });
      },
  
      successEdit() {
        this.$swal({
          title: "Bank edited!",
          text: "You have successfully edited a bank!",
          icon: "success",
          customClass: {
            confirmButton: "btn btn-primary",
          },
          buttonsStyling: false,
        });
      },
  
      // error
      errorEdit() {
        this.$swal({
          title: "Error!",
          text: " Failed!",
          icon: "error",
          customClass: {
            confirmButton: "btn btn-primary",
          },
          buttonsStyling: false,
        });
      },
  
      ...mapActions("bankModule", ["getBankListAction", "getBankIDAction", "addBankAction", "updateBankAction"]),
      ...mapActions("bankStatementModule", ["getUploadBankStatementAction", "getBankIDAction", "postUploadBankStatementAction", "updateBankAction"]),
      
  
      AddBankStatement() {
        let docForm = new FormData();
        docForm.append("bankID", this.bankId);
        docForm.append("File", this.file);
        // let payload = {
        //   BankId: this.id,
        //   File: docForm,
        // };
        this.postUploadBankStatementAction(docForm)
          .then(() => {
            this.successAdd();
            this.$bvModal.hide("addReconciliationModal");
            this.file = null;
            this.getUploadBankStatementAction();
          })
          .catch(() => {
            this.errorAdd();
            this.getUploadBankStatementAction();
          });
  
      },
  
      editBank() {
  
        let payload = {
          id: this.selectedBank.id,
          bankName: this.selectedBank.bankName,
          name: this.selectedBank.name,
          currency: this.selectedBank.currency,
          description: this.selectedBank.description,
          currentBalance: this.selectedBank.currentBalance,
          code: this.selectedBank.code,
          accountNumber: this.selectedBank.accountNumber,
          type: this.selectedBank.type,
          openingBalanceDate: this.selectedBank.openingBalanceDate,
          openingBalance: this.selectedBank.openingBalance,
        };
        this.updateBankAction(payload)
          .then(() => {
            this.successEdit();
            this.$bvModal.hide("editModal");
            this.getUploadBankStatementAction();
  
          })
          .catch(() => {
            this.errorEdit();
            this.$bvModal.hide("editModal");
            this.getUploadBankStatementAction();
          });
      },
  
      getStatusVariant(status) {
        return {
          Reconciled: "success",
          Unreconciled: "danger",
          Updating: "warning",
        }[status];
      },
  
      openAddModal() {
        this.showReconciliationModal = true;
      },
      closeAddModal() {
        this.showReconciliationModal = false;
      },
      openAddCCModal() {
        this.showAddCCModal = true;
      },
      openViewModal(bank) {
        this.selectedBank = bank;
        this.showViewModal = true;
      },
      openEditModal(bank) {
        this.selectedBank = bank;
        this.showEditModal = true;
      },
    },
    computed: {
      ...mapGetters("bankModule", {
        banks: "bank",
        loading: "loading",
      }),
      ...mapGetters("bankStatementModule", {
        bankStatement: "bankStatement",
        loading: "loading",
      }),
  
    },
    async mounted() {
      try{
        this.$swal({
      title: "Fetching data...",
      text: "Please wait while we load the reconciliations.",
      icon: "info",
      allowOutsideClick: false,
      showConfirmButton: false,
      didOpen: () => {
        this.$swal.showLoading();
      },
    });
        const response = await this.getUploadBankStatementAction(this.bankId);
        console.log("bank details:",response);
        if(response){
          this.reconciliation = response;
          this.totalRows = response.length;
        } else {
          console.warn("no data received", response);
          this.reconciliation = [];
        }
      }catch (e)
      {
           console.error("error fetching reconciliation", e);
           this.$swal({
      title: "Error!",
      text: "Failed to fetch data.",
      icon: "error",
      confirmButtonText: "OK",
    });
      }finally {
    this.$swal.close(); 
      }
    }
  };
  </script>
  <style>
  div #viewModal footer {
    display: none !important;
  }
  
  .input-group:not(.bootstrap-touchspin):focus-within {
    box-shadow: none;
  }
  </style>
  <style lang="scss">
  @import "@core/scss/vue/libs/vue-select.scss";
  @import "@core/scss/vue/libs/vue-flatpicker.scss";
  </style>